import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import loadingAnimaton from "@/components/loadingAnimaton/loadingAnimaton.vue";

var Toast =
/*#__PURE__*/
function (_Vue) {
  _inherits(Toast, _Vue);

  function Toast() {
    var _this;

    _classCallCheck(this, Toast);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toast).apply(this, arguments));
    _this.aniOn = false;
    _this.contentBoxWidth = 0;
    _this.contentBoxHeight = 0;
    _this.contentBorderWidth = 16;
    _this.contentBoxD = "";
    _this.contentSvgAnimateStyle = {};
    _this.showCloseBtnTime = 5;
    _this.showCloseBtnLater = false;
    return _this;
  }

  _createClass(Toast, [{
    key: "watchIndex",
    value: function watchIndex(val, oldVal) {
      console.log("isShow:", {
        val: val,
        oldVal: oldVal,
        isFuseAnimate: this.isFuseAnimate
      });

      if (val && this.isFuseAnimate) {
        //显示初始化svg animate
        this.initFuseAnimate();
      } else {
        this.showCloseBtnLater = false;
      }
    }
  }, {
    key: "clickConfirm",
    value: function clickConfirm() {
      this.confirmFn && this.confirmFn();
      !this.confirmNotClose && this.hideToast();
    }
  }, {
    key: "clickCancel",
    value: function clickCancel() {
      this.cancelFn && this.cancelFn();
      this.hideToast();
    }
  }, {
    key: "clickMask",
    value: function clickMask() {
      if (this.showCloseBtn) {
        return;
      }

      this.cancelFn && this.cancelFn();
      this.hideToast();
    }
  }, {
    key: "clickAllBtn",
    value: function clickAllBtn() {
      console.log("clickAllBtn");

      if (this.clickAllBtnOn) {
        this.clickConfirm();
      }
    }
  }, {
    key: "initFuseAnimate",
    value: function initFuseAnimate() {
      var _this2 = this;

      var loadImg = document.getElementById("load-img");
      var timer = setInterval(function () {
        if (document.getElementById("load-img") && document.getElementById("load-img").complete) {
          clearInterval(timer);
          var wrappeDom = document.getElementById("content-box");
          console.log("wrappeDom:", wrappeDom);
          _this2.contentBoxWidth = wrappeDom.clientWidth + _this2.contentBorderWidth;
          _this2.contentBoxHeight = wrappeDom.clientHeight + _this2.contentBorderWidth;
          console.log("this.contentBoxWidth:", wrappeDom.clientWidth, wrappeDom.clientHeight); //draw line

          _this2.contentBoxD = "\n          M".concat(_this2.contentBoxWidth / 2, " 0 L").concat(_this2.contentBoxWidth, " 0 L").concat(_this2.contentBoxWidth, " ").concat(_this2.contentBoxHeight, " L0 ").concat(_this2.contentBoxHeight, " L0 0 L").concat(_this2.contentBoxWidth / 2, " 0\n        "); //draw dash

          _this2.contentSvgAnimateStyle = {
            "stroke-dasharray": "".concat((_this2.contentBoxWidth + _this2.contentBoxHeight) * 2),
            transition: "stroke-dashoffset ".concat(_this2.showCloseBtnTime, "s, stroke-dasharray ").concat(_this2.showCloseBtnTime, "s"),
            "transition-timing-function": "linear",
            "stroke-dashoffset": "".concat((_this2.contentBoxWidth + _this2.contentBoxHeight) * 2)
          };
          setTimeout(function () {
            _this2.showCloseBtnLater = true;
          }, _this2.showCloseBtnTime * 1000);
        }
      }, 100);
    }
  }, {
    key: "isShow",
    get: function get() {
      return this.toastData.show;
    }
  }, {
    key: "title",
    get: function get() {
      return this.toastData.title;
    }
  }, {
    key: "titleColor",
    get: function get() {
      return this.toastData.titleColor ? this.toastData.titleColor : "";
    }
  }, {
    key: "showCloseBtn",
    get: function get() {
      return this.toastData.showCloseBtn ? this.toastData.showCloseBtn && this.showCloseBtnLater : false;
    }
  }, {
    key: "titleStyle",
    get: function get() {
      if (this.titleColor.indexOf("linear") > -1) {
        return {
          backgroundImage: this.titleColor,
          "-webkit-background-clip": "text",
          "-webkit-text-fill-color": "transparent"
        };
      } else {
        return {
          color: this.titleColor
        };
      }
    }
  }, {
    key: "topImg",
    get: function get() {
      return this.toastData.topImg;
    }
  }, {
    key: "content",
    get: function get() {
      return this.toastData.content;
    }
  }, {
    key: "confirm",
    get: function get() {
      return this.toastData.confirm ? this.toastData.confirm : "";
    }
  }, {
    key: "confirmNotClose",
    get: function get() {
      return this.toastData.confirmNotClose;
    }
  }, {
    key: "confirmFn",
    get: function get() {
      return this.toastData.confirmFn;
    }
  }, {
    key: "cancel",
    get: function get() {
      return this.toastData.cancel;
    }
  }, {
    key: "cancelFn",
    get: function get() {
      return this.toastData.cancelFn;
    }
  }, {
    key: "isFuseAnimate",
    get: function get() {
      return this.toastData.isFuseAnimate;
    }
  }, {
    key: "clickAllBtnOn",
    get: function get() {
      return this.toastData.clickAllBtn;
    }
  }, {
    key: "vipConfirmBtn",
    get: function get() {
      return this.toastData.vipConfirmBtn;
    }
  }]);

  return Toast;
}(Vue);

tslib_1.__decorate([Mutation(types.HIDE_TOAST)], Toast.prototype, "hideToast", void 0);

tslib_1.__decorate([Getter(types.GETTER_TOAST)], Toast.prototype, "toastData", void 0);

tslib_1.__decorate([Watch("isShow")], Toast.prototype, "watchIndex", null);

Toast = tslib_1.__decorate([Component({
  components: {
    loadingAnimaton: loadingAnimaton
  }
})], Toast);
export default Toast;